export const PHONE_DEFAULT_COUNTRY_CODE = "in"